
<div style="padding: 30px;">
  <quill-editor
    [(ngModel)]="editorContent"
    [modules]="editorModules"
    [readOnly]="false"
    (onEditorCreated)="onEditorCreated($event)"
    style="height: 300px; width: 100%;"
  ></quill-editor>
</div>

<div style="display: flex; justify-content: flex-end; padding: 0 30px 30px 30px;">
    <button mat-raised-button color="primary"  (click)="back()" class="me-2 onlyhover">
    Back
    </button>&nbsp;&nbsp;
  <button mat-raised-button color="primary" class="onlyhover" (click)="savecheck()">
    Submit
  </button>
</div>
<ng-template #emailDialog>
  <mat-dialog-content>
    <div class="first-row">
      <span class="title">
        Congratulations! Your Rental Agreement PDF is ready. Just pick an email address to send it off!
      </span>
      <div class="close-container">
        <button class="close-button" (click)="dialogRef.close()">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Owner Email (Only if email exists) -->
    <div class="otp-card email-section" *ngIf="data?.ownerEmail">
      <strong>Owner Email</strong>
      <div
        class="email-select-chip"
        [class.selected]="isOwnerSelected"
        (click)="toggleOwnerEmail()"
      >
        <i
          class="fa"
          [ngClass]="isOwnerSelected ? 'fa-check-circle' : 'fa-circle-thin'"
        ></i>
        <span>{{ data.ownerEmail }}</span>
      </div>
    </div>

    <!-- Tenant Email (Only if email exists) -->
    <div class="otp-card email-section" *ngIf="data?.tenantEmail">
      <strong>Tenant Email</strong>
      <div
        class="email-select-chip"
        [class.selected]="isTenantSelected"
        (click)="toggleTenantEmail()"
      >
        <i
          class="fa"
          [ngClass]="isTenantSelected ? 'fa-check-circle' : 'fa-circle-thin'"
        ></i>
        <span>{{ data.tenantEmail }}</span>
      </div>
    </div>

    <!-- Submit Button -->
    <div
      class="custom-submit-btn onlyhover"
      [class.disabled]="!isAnyEmailSelected"
      (click)="sendAgreement()"
    >
      Submit
    </div>
  </mat-dialog-content>
</ng-template>
